import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type DefaultState = {
  commonList: any
  page: number,
  prevPage: number,
  sortBy: { sort: string, title: string};
  periodValue: number[],
  maxYear: number,
  periodValueUI: number[]
  genresValue: number[]
}

const initialState: DefaultState = {
  commonList: [],
  page: 1,
  prevPage: 0,
  sortBy: { sort: 'popularity.desc', title: 'Popularity' },
  maxYear: 2025,
  periodValue: [1980, 2025],
  periodValueUI: [1980, 2025],
  genresValue: []
}

export const ListsSlice = createSlice({
  name: "lists",
  initialState: initialState,
  reducers: {
    setInitialList: (state, action: PayloadAction<any>) => {
      state.commonList = action.payload
    },
    setDataToList: (state, action: PayloadAction<any>) => {
      state.commonList = [...state.commonList, ...action.payload];
    },
    setPrevPage: (state, action: PayloadAction<number>) => {
      state.prevPage = action.payload
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = state.page + action.payload
    },
    setSortBy: (state, action: PayloadAction<{ sort: string, title: string }>) => {
      state.sortBy = action.payload
    },
    cleanUpPage: (state) => {
      state.page = 1;
      state.prevPage = 0;
      state.commonList = []
    },
    setPeriodValue: (state, action: PayloadAction<number[]>) => {
      state.periodValue = action.payload
    },
    setPeriodValueUI: (state, action: PayloadAction<number[]>) => {
      state.periodValueUI = action.payload
    },
    setGenresValue: (state, action: PayloadAction<number[]>) => {
      state.genresValue = action.payload
    },
    setVoteCount: (state, action: PayloadAction<{id: number, key: string, type: string}>) => {
      const dat: any = [...state.commonList];
      const itemIndex = dat.findIndex((item: any) => item.id === action.payload.id);
      if (itemIndex !== -1) {
        dat[itemIndex] = {
          ...dat[itemIndex],
          vote_count: action.payload.type === 'increment' ? dat[itemIndex].vote_count + 1 : dat[itemIndex].vote_count - 1
        };
      }

      state.commonList = dat;
    },
    resetGenresValue: (state) => {
      state.genresValue = []
    },
    setMaxYearList: (state, action: PayloadAction<number>) => {
      state.maxYear = action.payload;
      state.periodValue = [1980, action.payload];
      state.periodValueUI = [1980, action.payload];
    }
  },
})

export default ListsSlice.reducer
export const {
  setInitialList,
  setDataToList,
  setVoteCount,
  setMaxYearList,
  setPage,
  cleanUpPage,
  setSortBy,
  setPeriodValue,
  setPeriodValueUI,
  setGenresValue,
  setPrevPage,
  resetGenresValue
} = ListsSlice.actions
